import { Box, Grid } from '@mui/material'; // Use the standard Grid
import React, { useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';

import CardsHeader from './components/CardsHeader';
import BestTeamCard from './components/BestTeamCard';
import BestTeamListCard from './components/BestTeamListCard';
import ProjectAnalyticsCard from './components/ProjectAnalyticsCard';
import OGDPerformers from './components/OGDPerformers';
import MilestoneAchieversCard from './components/MilestoneAchieversCard';
import { TopAchieversCard } from './components/TopAchieversCard';
import { DailyRevenueCard } from './components/DailyRevenueCard';
import AssessmentTotalCard from './components/AssessmentTotalCard';
import DailyRevenueTableCard from './components/DailyRevenueTableCard';
import MonthlyWiseGlobalFilter from '../TeamWiseAnalytics/MonthlyWiseGlobalFilter';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { getBestTeamperformance } from '../../../../redux/features/poinTrackerSlice';

export default function OverViewLanding() {
  const [overviewFromdate, setOverviewFromdate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [overviewTodate, setOverviewTodate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [overviewSelectedTeam, setOverviewSelectedTeam] = useState({ id: -1, value: 'All' });

  const [refreshing, setRefreshing] = useState(false);

  const ONE_MINUTE = 60 * 1000;
  const API_REFRESH_TIME = 90 * 1000; // 1.5 minutes

  const dispatch = useDispatch();
  const { loading, responseData, lastTime } = useSelector((state) => state.pointTracker.bestTeamList);

  const [timeAgo, setTimeAgo] = useState('');

  const dispatchParams = useMemo(() => {
    return {
      fromDate: overviewFromdate,
      toDate: overviewTodate,
      wingId: overviewSelectedTeam?.id === -1 ? null : overviewSelectedTeam?.id,
    };
  }, [overviewFromdate, overviewTodate, overviewSelectedTeam?.id]);

  useEffect(() => {
    if (overviewFromdate && overviewTodate) {
      dispatch(getBestTeamperformance(dispatchParams));
    }
  }, [dispatch, dispatchParams]);

  // const handleBestTeamRefresh = async () => {
  //   try {
  //     await dispatch(getBestTeamperformance(dispatchParams)).unwrap();
  //   } catch (err) {
  //     console.error('Refresh error:', err);
  //   }
  // };
  const handleBestTeamRefresh = async () => {
    setRefreshing(true);
    try {
      await dispatch(getBestTeamperformance(dispatchParams)).unwrap();
    } catch (err) {
      console.error(err);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (!lastTime) return;

    const updateTimeAgo = () => {
      const seconds = Math.floor((Date.now() - lastTime) / 1000);
      const minutes = Math.floor(seconds / 60);

      if (minutes === 0) {
        setTimeAgo('Just now');
      } else {
        setTimeAgo(`${minutes} min ago`);
      }
    };
    updateTimeAgo();

    const labelInterval = setInterval(updateTimeAgo, ONE_MINUTE);

    const apiTimeout = setTimeout(() => {
      dispatch(getBestTeamperformance(dispatchParams));
    }, API_REFRESH_TIME); //  readable

    return () => {
      clearInterval(labelInterval);
      clearTimeout(apiTimeout);
    };
  }, [lastTime, dispatch, dispatchParams]);

  return (
    <GlobalWrapper title={'OverView'}>
      <MonthlyWiseGlobalFilter
        fromDate={overviewFromdate}
        setFromDate={setOverviewFromdate}
        toDate={overviewTodate}
        setToDate={setOverviewTodate}
        setSelectedTeam={setOverviewSelectedTeam}
        selectedTeam={overviewSelectedTeam}
      />
      <CardsHeader fromDate={overviewFromdate} toDate={overviewTodate} selectedTeam={overviewSelectedTeam} />
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6} lg={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <BestTeamCard
              data={responseData}
              loading={loading}
              onRefresh={handleBestTeamRefresh}
              refreshing={refreshing}
              lastUpdated={timeAgo}
            />
            <BestTeamListCard
              data={responseData}
              loading={loading}
              onRefresh={handleBestTeamRefresh}
              refreshing={refreshing}
              lastUpdated={timeAgo}
            />
            <ProjectAnalyticsCard
              fromDate={overviewFromdate}
              toDate={overviewTodate}
              selectedTeam={overviewSelectedTeam}
            />
          </Box>
        </Grid>

        {/* COLUMN 2: MIDDLE (Performers) */}
        <Grid item xs={12} md={6} lg={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <OGDPerformers fromDate={overviewFromdate} toDate={overviewTodate} selectedTeam={overviewSelectedTeam} />
            <TopAchieversCard fromDate={overviewFromdate} toDate={overviewTodate} selectedTeam={overviewSelectedTeam} />
            <DailyRevenueCard fromDate={overviewFromdate} toDate={overviewTodate} selectedTeam={overviewSelectedTeam} />
          </Box>
        </Grid>

        <Grid item xs={12} md={12} lg={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <MilestoneAchieversCard
              fromDate={overviewFromdate}
              toDate={overviewTodate}
              selectedTeam={overviewSelectedTeam}
            />
            <DailyRevenueTableCard
              fromDate={overviewFromdate}
              toDate={overviewTodate}
              selectedTeam={overviewSelectedTeam}
            />
            <AssessmentTotalCard
              fromDate={overviewFromdate}
              toDate={overviewTodate}
              selectedTeam={overviewSelectedTeam}
            />
          </Box>
        </Grid>
      </Grid>
    </GlobalWrapper>
  );
}
